module.exports = __webpack_public_path__ + "static/media/baseMeme5thumb.c0ffe3d1.jpg";